import { areArraysEquivalent } from '../../../../utils/equivalence-utils';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { getOrder } from '../../selectors/order/get-order';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
import { getReservedOrderSeatIdsForShowtime } from '../../selectors/seats/get-reserved-order-seat-ids-for-showtime';
import { assertIsStandardOrder } from '../../utils/order-type-utils';
import { saveOrderShowtime } from '../showtimes/save-order-showtime';
export const saveOrderSeatsForShowtime = async (showtimeId) => {
    const order = getOrder();
    assertIsStandardOrder(order, 'Cannot save order seats');
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot save order seats. Provided showtimeId is invalid.');
    }
    const orderSelections = getOrderSelections();
    if (!orderSelections.showtime || orderSelections.showtime.showtimeId !== showtimeId) {
        logger.debug(`Cannot save order seats. Seats for showtime '${showtimeId}' are already in sync with the API.`);
        return;
    }
    const seatsMatchReservedSeats = areArraysEquivalent(getReservedOrderSeatIdsForShowtime(showtimeId), orderSelections.showtime.seats.map(s => s.seatId));
    if (seatsMatchReservedSeats) {
        logger.debug(`Cannot save order seats. Seats for showtime '${showtimeId}' are already in sync with the API.`);
        return;
    }
    return saveOrderShowtime(showtimeId);
};
